const escapeTooltipHtml = (value) =>
  String(value ?? "").replace(/[&<>"']/g, (character) => {
    const entities = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };
    return entities[character];
  });

export const buildScheduledMessageTooltip = (name, sendRule) =>
  JSON.stringify({
    title: `<b>${escapeTooltipHtml(name)}</b><br>${escapeTooltipHtml(sendRule)}`,
    delay: 0,
  });
